const messages = {
    accountBox: {
        title: "Vadības panelis",
        description: "Ātri sekojiet savām akcijām un punktiem.",
        button: "ATVĒRT VADĪBAS PANELI",
    },
};

export default {
    messages,
};
